export default __webpack_public_path__ + "static/media/notfaund.c2940720.png";